import { Box, CircularProgress, Typography } from "@mui/joy";

export function getToolComposingMessage(label?: string | null): string {
  if (!label || label === "Working") return "Working...";
  if (label === "your request") return "Preparing your request…";
  return `Preparing: ${label}…`;
}

export function ToolComposingIndicator({ label }: { label?: string | null }) {
  return (
    <Box
      data-testid="chat-working-indicator"
      role="status"
      aria-live="polite"
      sx={{ display: "flex", alignItems: "center", gap: 1, mx: 4, mt: 0.5 }}
    >
      <CircularProgress size="sm" />
      <Typography level="body-sm">{getToolComposingMessage(label)}</Typography>
    </Box>
  );
}
